import { createFileRoute, redirect } from "@tanstack/react-router";

import { SettingsPage } from "@/features/Settings/SettingsPage";
import {
  smsRegistrationRouteRedirect,
  useSmsRegistrationAccess,
} from "@/features/Settings/smsRegistrationAccess";
import { SmsRegistrationTab } from "@/features/Settings/tabs/SmsRegistrationTab";

export const Route = createFileRoute(
  "/_auth/settings/$siteId/sms-registration",
)({
  beforeLoad: ({ context, params }) => {
    const target = smsRegistrationRouteRedirect(
      context.auth?.user?.user.role,
      params.siteId,
    );
    if (target) throw redirect(target);
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { siteId } = Route.useParams();
  const canAccess = useSmsRegistrationAccess();

  return (
    <SettingsPage
      title="SMS registration"
      description="Register this site with InfoBip so it can send texts."
      access={canAccess}
      data-testid="settings-sms-registration-page"
    >
      <SmsRegistrationTab key={siteId} siteId={siteId} />
    </SettingsPage>
  );
}
